const Formatters = {
  install(Vue) {
    Vue.prototype.$dateFormat = function(value) {
      return this.$moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
}

export default Formatters
